<template>
  <div v-if="loading" class="loading-screen">
    <img src="/logo-roboto.png" alt="Logo" class="loading-logo" />
  </div>
  <div v-else class="home-page">
    <a href="https://wa.me/+201118696626" target="_blank" class="whatsapp-float" title="WhatsApp">
      <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
    </a>
      
    <swiper
      :slides-per-view="1"
      :loop="true"
      :autoplay="{ delay: 500, disableOnInteraction: false }"
      :pagination="{ clickable: true }"
      :effect="'slide'"
      :direction="'horizontal'"
      class="main-swiper"
    >
      <swiper-slide v-for="(slide, idx) in slides" :key="idx">
        <div class="slide-content">
          <img :src="slide.image" class="slide-img" alt="slide.title" />
          <div class="slide-info-overlay">
            <h2>{{ slide.title }}</h2>
            <p>{{ slide.desc }}</p>
            <router-link to="/vision" class="slide-btn">Learn more ..</router-link>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <section class="about-section">
      <div class="about-content">
        
        <div class="about-text">
          <h2>Children's Robotics Academy</h2>
          <p>
            We offer specialized educational programs in robotics and programming for children, with interactive workshops to enhance their thinking and creativity skills.          </p>
          <router-link to="/programs" class="about-btn">Get to Know the Academy</router-link>
        </div>
        <img src="wesd.jpeg" alt="أكاديمية روبوتكس" class="about-img" />
      </div>
    </section>
  <section class="facility-section">
    <div class="facility-content">
      <img src="wewfff.jpeg" alt="تجهيز الأكاديمية" class="facility-img" />
      <div class="facility-text">
        <h2>Robotics Academy Facilities</h2>
        <p>
             The academy is equipped with the latest tools and technologies in robotics and programming, providing a safe and stimulating learning environment for children. We offer advanced labs and modern devices to deliver a hands-on and inspiring educational experience.        </p>
        <router-link to="/about" class="facility-btn">Learn More About Us</router-link>
      </div>
    </div>
  </section>
  </div>
  <section class="programs-section">
      <h2 class="programs-title">Our Educational Programs for Children</h2>
      <div class="programs-list">
        <div class="program-card">
          <img src="ddsss.png" alt="برمجة الروبوتات" class="program-img" />
          <div class="program-info">
            <h3>Robotics Programming</h3>
            <p>Learn the basics of programming through practical and interactive projects using modern robots.</p>
          </div>
        </div>
        <div class="program-card">
          <img src="1dfdfdc.png" alt="ورش عمل تفاعلية" class="program-img" />
          <div class="program-info">
            <h3>Interactive Workshops</h3>
            <p>Weekly workshops to develop children's creative thinking and problem-solving skills through robotics.</p>
          </div>
        </div>
        <div class="program-card">
          <img src="waffg.png" alt="تحديات ومسابقات" class="program-img" />
          <div class="program-info">
            <h3>Challenges and Competitions</h3>
            <p>Organizing fun competitions and challenges to encourage children to be innovative and work collaboratively in the field of robotics.</p>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Autoplay, Pagination } from 'swiper';

SwiperCore.use([Autoplay, Pagination]);

export default {
  name: 'HomePage',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      loading: true,
      slides: [
        {
          image: 'dfdfd.jpeg',
          title: 'Welcome to Roboto School',
          desc: 'At Roboto School, we believe the future belongs to those who can create it. Since 2013,',
          link: 'https://academy-robotics.com'
        },
        {
          image: 'wqw.jpeg',
          title: 'we’ve been inspiring children',
          desc: 'teens to discover the power of coding, artificial intelligence, and robotics',
          link: 'https://academy-robotics.com/programming'
        },
        {
          image: 'wwwww.jpeg',
          title: 'Our mission is simple',
          desc: 'to empower the next generation of innovators with the skills they need to thrive in a rapidly changing world.',
          link: 'https://academy-robotics.com/workshops'
        }
      ]
    };
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }
};
</script>

<style>
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #ffffff;
}
.loading-logo {
  width: 150px;
  height: auto;
}
.whatsapp-float {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 3000;
  background: #25d366;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.2s;
}
.whatsapp-float:hover {
  box-shadow: 0 4px 16px rgba(37,211,102,0.25);
}
.whatsapp-float img {
  width: 36px;
  height: 36px;
  display: block;
}
/* تصميم الفوتر */
.main-footer {
  background: #222;
  color: #fff;
  padding: 2.5rem 1rem 1rem 1rem;
  margin-top: 60px;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto;
  flex-wrap: wrap;
}
.footer-section {
  flex: 1;
  min-width: 220px;
  margin-bottom: 1.5rem;
}
.footer-section h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: #ffd600;
}
.footer-section p, .footer-section a {
  font-size: 1rem;
  color: #fff;
  margin-bottom: 0.5rem;
  text-decoration: none;
}
.footer-links {
  list-style: none;
  padding: 0;
}
.footer-links li {
  margin-bottom: 0.5rem;
}
.footer-links a {
  color: #90caf9;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-links a:hover {
  color: #ffd600;
}
.footer-bottom {
  text-align: center;
  padding-top: 1rem;
  font-size: 0.95rem;
  color: #bbb;
  border-top: 1px solid #444;
}
@media (max-width: 900px) {
  .footer-content {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }
  .footer-section {
    min-width: unset;
    text-align: center;
  }
}
/* سكشن تجهيز الأكاديمية */
.facility-section {
  width: 100%;
  max-width: 1100px;
  margin: 40px auto 0 auto;
  padding: 2rem 1rem;
}
.facility-content {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  background: #e3f2fd;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(25,118,210,0.07);
  padding: 2rem;
}
.facility-img {
  width: 340px;
  height: 260px;
  object-fit: cover;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(25,118,210,0.10);
}
.facility-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.facility-text h2 {
  font-size: 2rem;
  color: #1976d2;
  margin-bottom: 1rem;
}
.facility-text p {
  font-size: 1.15rem;
  color: #333;
  margin-bottom: 1.5rem;
}
.facility-btn {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.7rem 1.5rem;
  background: #1976d2;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1.1rem;
  font-weight: bold;
  transition: background 0.3s, transform 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.facility-btn:hover {
  background: #1565c0;
  transform: translateY(-3px);
}
@media (max-width: 900px) {
  .facility-content {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
  .facility-img {
    width: 100%;
    height: 200px;
  }
  .facility-text {
    align-items: center;
  }
}
/* سكشن البرامج */
.programs-section {
  width: 100%;
  max-width: 1100px;
  margin: 40px auto;
  padding: 2rem 1rem;
  background: linear-gradient(to bottom, #ffffff, #e3f2fd);
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.programs-title {
  text-align: center;
  font-size: 2.5rem;
  color: #1565c0;
  margin-bottom: 2rem;
  font-weight: bold;
}
.programs-list {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}
.program-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1rem;
  transition: transform 0.3s, box-shadow 0.3s;
}
.program-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
.program-img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 1rem;
}
.program-info h3 {
  font-size: 1.5rem;
  color: #1565c0;
  margin-bottom: 0.5rem;
  text-align: center;
}
.program-info p {
  font-size: 1.1rem;
  color: #555;
  text-align: center;
  line-height: 1.6;
}
@media (max-width: 900px) {
  .programs-list {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }
  .program-card {
    width: 98vw;
    max-width: 350px;
  }
}
/* سكشن الأكاديمية */
.about-section {
  width: 100%;
  max-width: 1100px;
  margin: 40px auto 0 auto;
  padding: 2rem 1rem;
}
.about-content {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  background: #f7f7f7;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  padding: 2rem;
}
.about-img {
  width: 340px;
  height: 260px;
  object-fit: cover;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}
.about-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.about-text h2 {
  font-size: 2rem;
  color: #1976d2;
  margin-bottom: 1rem;
}
.about-text p {
  font-size: 1.15rem;
  color: #333;
  margin-bottom: 1.5rem;
}
.about-btn {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.7rem 1.5rem;
  background: #1976d2;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1.1rem;
  font-weight: bold;
  transition: background 0.3s, transform 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.about-btn:hover {
  background: #1565c0;
  transform: translateY(-3px);
}
@media (max-width: 900px) {
  .about-content {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
  .about-img {
    width: 100%;
    height: 200px;
  }
  .about-text {
    align-items: center;
  }
}
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@700&display=swap');
.home-page {
  margin-top: 70px;
  font-family: 'Cairo', sans-serif;
  background: linear-gradient(to bottom, #e3f2fd, #ffffff);
  padding: 2rem 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}
    .main-swiper {
      width: 100%;
      height: 450px; /* Adjusted height for better visibility */
      position: relative;
      margin-bottom: 2rem;
      border-radius: 15px; /* Slightly increased border radius */
      overflow: hidden;
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15); /* Enhanced shadow for better aesthetics */
    }
  
.slide-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)); /* Added gradient overlay */
}
.slide-img {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.slide-info-overlay {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.slide-btn {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #1976d2;
  color: #fff;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s;
}

.slide-btn:hover {
  background-color: #145a9e;
}
.about-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.about-text {
  flex: 1;
}
.about-text h2 {
  font-size: 2rem;
  color: #1565c0;
  margin-bottom: 1rem;
}
.about-text p {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
}
.about-btn {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.7rem 1.5rem;
  background: #1976d2;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s, transform 0.3s;
}
.about-btn:hover {
  background: #1565c0;
  transform: translateY(-3px);
}
.about-img {
  flex: 1;
  max-width: 400px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.facility-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.facility-text {
  flex: 1;
}
.facility-text h2 {
  font-size: 2rem;
  color: #1565c0;
  margin-bottom: 1rem;
}
.facility-text p {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
}
.facility-img {
  flex: 1;
  max-width: 400px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.home-cover img {
  width: 100%;
  height: auto;
}

.home-section {
  user-select: none; /* Disable text selection */
}

body {
  zoom: 1; /* Prevent zoom */
}
</style>

